<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <div class="design">
        <i class="el-icon-plus"></i>
      </div>
      <p>{{ placeholder }} {{ sizeTip }}</p>
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <el-upload :file-list="fileList" :action="$apis.common.uploadQiniup" :limit="maxNumber" :multiple="maxNumber > 1"
        :data="uploadParams" :on-success="uploadSuccess" :on-preview="handlePictureCardPreview"
        :on-remove="handleRemove" :on-exceed="overLimit" :on-error="uploadFail" list-type="picture-card" auto-upload
        :before-upload="beforeUpload">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" style="height: 100%;" slot-scope="{file}">
          <img class="el-upload-list__item-thumbnail" style="object-fit: cover;" :src="file.url + `${file.name.includes('mp4') ? '?vframe/jpg/offset/1' : ''}`" alt="">
          <span class="el-upload-list__item-actions">
            <!-- <span class="el-upload-list__item-preview">
              <i class="el-icon-zoom-in"></i>
            </span> -->
            <!-- <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span> -->
            <span class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
        <div slot="tip" class="el-upload__tip">{{ placeholder }} {{ sizeTip }}</div>
      </el-upload>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <uploader v-model="fileList" :multiple="maxNumber > 1" :max-count="maxNumber > 0 ? maxNumber : 99" deletable
        :before-delete="handleRemove" :before-read="beforeUpload" upload-text="选择图片" :after-read="afterRead"
        :max-size="maxSize * 1024 * 1024" @oversize="onOversize" />
      <div style="color:#9b9595;">{{ placeholder }} {{ sizeTip }}</div>
    </div>
    <div v-else class="img-preview">
      <div class="img-preview-pc">
        <div v-for="(img, index) in _value" class="img-item">
          <el-image :alt="img.name" fit="cover" :src="$getRes(img.url) + (img.isImage ? '' : '?vframe/jpg/offset/1')"
            @click="previewMedia(index)" />
          <img class="play" @click="previewMedia(index)" v-if="!img.isImage" src="@/assets/image/play.png"></img>
        </div>
      </div>
    </div>

    <image-viewer :visible.sync="dialogVisible" :url-list="formatFileList" :initial-index="currentIndex"></image-viewer>
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer'
import { Uploader, Toast } from 'vant';
import componentMinxins from '../ComponentMinxins'
import { getUUID } from '@/utils/formatData'
import { picDns, videoDns, fileDns, bucket } from '@/components/uploadFile/config'

export default {
  mixins: [componentMinxins],
  name: "ImageUpload",
  components: { Uploader, ImageViewer },
  props: {
    mode: {
      type: String,
      default: 'DESIGN'
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择图片'
    },
    maxSize: {
      type: Number,
      default: 5
    },
    maxNumber: {
      type: Number,
      default: 10
    },
    enableZip: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    sizeTip () {
      return this.maxSize > 0 ? `| 每张图不超过${this.maxSize}MB` : ''
    },
    pcImgList () {
      return this._value.filter(item => item.isImage).map(v => this.$getRes(v.url))
    },
    formatFileList () {
      return this._value.map(item => {
        return { url: item.url, name: item.name }
      })
    },
    fileList: {
      get () {
        return (this._value || []).map(f => {
          return {
            name: f.name,
            url: this.$getRes(f.url),
            status: 'success'
          }
        })
      },
      set (val) { }
    }
  },
  data () {
    return {
      dialogVisible: false,
      currentIndex: 0,
      loading: false,
      disabled: false,
      uploadUrl: `${this.BASE_URL}/wflow/res`,
      uploadParams: {
        token: '',
        key: ''
      },
      catchList: [],
      alows: ['image/jpeg', 'image/png', 'image/gif', 'image/jpg', 'video/mp4', 'video/quicktime']
    }
  },
  created () {
    this.getToken()
  },
  methods: {
    previewMedia (index) {
      this.currentIndex = index
      this.dialogVisible = true
    },
    getToken () {
      this.$axios.get(this.$apis.common.uploadToken, { bucket }).then(res => {
        this.uploadParams.token = res
      })
    },
    beforeUpload (file) {
      this.catchList.length = 0
      if (Array.isArray(file)) {
        for (let i = 0; i < file.length; i++) {
          if (!this.validImage(file[i])) {
            return false;
          }
        }
        return true;
      } else {
        return this.validImage(file)
      }
    },
    validImage (img) {
      this.setKey()
      if (this.alows.indexOf(img.type) === -1) {
        this.$message.warning("存在不支持的格式")
        // this.$message.warning("存在不支持的图片格式")
      } else if (this.maxSize > 0 && img.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`)
      } else {
        this.loading = true
        return true
      }
      return false
    },
    removeFile (fileId) {
      this.$axios.delete(`${this.BASE_URL}/wflow/res/${fileId}`).then(rsp => {
        this.$message.success('移除文件成功');
      })
    },
    uploadSuccess (res, file, fileList) {
      this.loading = false
      const item = {
        id: res.hash,
        isImage: file.raw.type.includes('image'),
        name: file.name,
        size: 27528,
        url: picDns + res.key
      }
      this.catchList.push(item)
      let ft = fileList.filter(f => f.size !== undefined)
      if (this.catchList.length === ft.length) {
        this.$emit('input', [...(this._value || []), ...this.catchList])
      }
      // this.$message.success(response.name + '上传成功')
      this.$message.success('上传成功')
    },
    uploadFail (err) {
      this.loading = false
      this.$message.error('图片上传失败 ' + err)
    },
    afterRead (file) {
      if (Array.isArray(file)) {
        file.forEach(fl => {
          this.uploadFile(fl)
        })
      } else {
        this.uploadFile(file)
      }
    },
    setKey () {
      const date = new Date()
      this.uploadParams.key = `${date.getFullYear()}${(date.getMonth() + 1)}${date.getDate()}/${getUUID()}`
    },
    uploadFile (file) {
      //上传文件
      const date = new Date()
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("key", `${date.getFullYear()}${(date.getMonth() + 1)}${date.getDate()}/${getUUID()}`)
      this.$axios.post(this.$apis.common.uploadQiniup, formData, {
        'Content-type': 'multipart/form-data'
      }).then(res => {
        if (res.status === 200) {
          this._value.push(res.data)
          this.$emit('input', this._value)
          Toast.success('上传成功')
        }
      }, err => {
        Toast.fail('上传失败')
        console.log(err)
      })
    },
    overLimit () {
      if (this.mode === 'PC') {
        this.$message.warning('最多只能上传' + this.maxNumber + '个图片或视频')
      } else {
        Toast.fail('数量超出限制')
      }
    },
    onOversize (file) {
      Toast.fail('图片过大')
    },
    handleRemove (file, fileList) {
      let i = this._value.findIndex(v => v.name === file.name)
      if (i > -1) {
        //this.removeFile(this._value[i].id)
        this._value.splice(i, 1)
        this.$emit('input', this._value)
      }
      console.log('删除文件', file)
    },
    handlePictureCardPreview (file) {
      console.log(file)
    },
    handleDownload (file) {
      console.log(file);
    }
  }
}
</script>

<style lang="less" scoped>
.design {
  i {
    padding: 10px;
    font-size: xx-large;
    background: white;
    border: 1px dashed #8c8c8c;
  }
}

/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 87px;
}

/deep/ .el-upload-list__item {
  width: 80px;
  height: 80px;
  transition: none;

  .el-upload-list__item-actions {
    &>span+span {
      margin: 1px;
    }
  }
}

// /deep/ .el-upload-list__item-preview {
//   display: none !important;
// }

.img-preview {
  /deep/ .img-preview-pc {
    display: flex;
    flex-wrap: wrap;

    .img-item {
      position: relative;
    }

    .play {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      z-index: 10;
      margin: 0;
    }

    .el-image {
      width: 80px;
      height: 80px;
      margin: 5px;
      cursor: pointer;
      vertical-align: top;
    }
  }
}
</style>
